import { render, staticRenderFns } from "./Unit.vue?vue&type=template&id=8e28eb36"
import script from "./Unit.vue?vue&type=script&lang=js"
export * from "./Unit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports